<template>
  <div class="container-table">

    <div class="row divAddPlan">
      <div v-if="optionSelected===undefined || optionSelected.name==respuesta_negativa" class="divInfo col-8">
        <span v-if="!isManual">*Campos obligatorios: introducir al menos una acción nueva o una acción asociada para poder aguardar cambios.</span>
      </div>
      <div v-if="optionSelected !== undefined && optionSelected.name==respuesta_afirmativa" class="divInfo col-8">
      </div>

      <div class="col-4">
        <q-btn
          unelevated
          icon="attach_file"
          class="bSecondary rigth"
          label="ASOCIAR ACCIÓN EXISTENTE"
          @click="triggerAdd()"
          :disabled="listadoAcciones.length===0? true : false"
          :style="isOnlyAccess? 'display: none': ''"
        />
      </div>
    </div>

    <PopUpAccionesAsociadas
    v-model="showPopUpAccionesAsociadas"
    :listadoAccionesParaAsociar="listadoAccionesParaAsociar.length>0 ? listadoAccionesParaAsociar : []"
    :listadoAcciones="listadoAcciones"/>

    <q-card-section>
      <q-table
        data-cy="accion-instrumeto-table"
        title="Acciones asociadas"
        :data="accionesAsociadas"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        :visible-columns="visibleColumns"
      >
        <template
v-slot:body-cell-estado="props"
          ><q-td data-cy="estado" :props="props" key="estado">{{
            props.selected ? 'Visible' : ''
          }}</q-td></template
        >
        <template v-slot:body-cell-nombre="props">
          <q-td key="nombre" :props="props">
            {{ props.row.nombre }}
          </q-td>
        </template>
        <template v-slot:body-cell-fase="props">
          <q-td key="fase" :props="props">
            <QChipFases :value="props.row.fase"/>
          </q-td>
        </template>
        <template v-slot:body-cell-objetivosRelacionados="props">
          <q-td key="objetivosRelacionados" :props="props">
            <q-img
              v-for="obj in props.row.objetivosRelacionados"
              v-bind:key="obj.file.url"
              :src="getImgObjetivo(obj.file)"
              :alt="getImgObjetivo(obj.file).url"
            >
              <q-tooltip anchor="bottom middle" :offset="[0, 10]">
                <strong>{{obj.name}}</strong>
              </q-tooltip>
            </q-img>
          </q-td>
        </template>

        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </q-card-section>
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      dataCy="delete-accion"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar la asociación? ${rowSelectedtoDelete.name}`
      "
      @save="deleteAccion()"
    />
  </div>
</template>
<script>
import { QTable, QTd, QImg } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import PopUpAccionesAsociadas from '@/components/PlanAccion/components/PopUpAccionesAsociadas.vue';
import Resources from '@/components/shared/mixins/Resources.js';
import QChipFases from '@/components/PlanAccion/components/QChipFases.vue';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import Const from '@/components/shared/helpers/Const.js';

export default {
  components: {
    QTable,
    QTd,
    QImg,
    DialogDelete,
    PopUpAccionesAsociadas,
    QChipFases
  },
  props: {
    isLoading: Boolean,
    accionesAsociadas: Array,
    optionSelected: Object,
    idIndicador: String,
    tipoIndicador: String,
    isManual: Boolean
  },
  mixins: [Loading, Resources],
  data () {
    return {
      rowSelectedtoDelete: null,
      pagination: {
        rowsPerPage: 20
      },
      showDialogDelete: false,
      showPopUpAccionesAsociadas: false,
      listadoAccionesParaAsociar: [],
      listadoAcciones: [],
      respuesta_afirmativa: Const.RESPUESTA_AFIRMATIVA,
      respuesta_negativa: Const.RESPUESTA_NEGATIVA,
      visibleColumns: ['name', 'fase', 'plazo', 'objetivosRelacionados', 'agenteResponsable', 'eliminar'],
      columns: [
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true,
          style: 'max-width: 700px'
        },
        {
          name: 'fase',
          label: 'Fase',
          align: 'left',
          field: 'fase',
          sortable: true
        },
        {
          name: 'plazo',
          label: 'Plazo',
          align: 'left',
          field: 'plazo',
          sortable: true
        },
        {
          name: 'objetivosRelacionados',
          label: 'Otros objetivos relacionados',
          align: 'left',
          field: 'objetivosRelacionados',
          sortable: true
        },
        {
          name: 'agenteResponsable',
          label: 'Agente responsable',
          align: 'left',
          field: 'agenteResponsable',
          sortable: true
        },
        {
          name: 'eliminar',
          label: 'Eliminar Asociación',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  created () {
    this.visibleColumns = this.isOnlyAccess ? ['name', 'fase', 'plazo', 'objetivosRelacionados', 'agenteResponsable'] : ['name', 'fase', 'plazo', 'objetivosRelacionados', 'agenteResponsable', 'eliminar'];
    if (this.tipoIndicador !== 'satelital') {
      this.getListadoAccionesAsociadas();
    } else {
      this.getListadoAccionesAsociadasSatelitales();
    }
  },
  mounted () {
    this.$eventHub.$on('saveAccionesAsociadas', acciones => {
      acciones.forEach(accion => {
        this.accionesAsociadas.push(accion);
        let dataIndicador = this.accionesAsociadas;
        this.$emit('updateDataIndicadorAccionesAsociadas', dataIndicador);
      });
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('saveAccionesAsociadas');
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deleteAccion () {
      // obtenemos indice
      const index = this.accionesAsociadas.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.accionesAsociadas.splice(index, 1);
      this.showDialogDelete = false;

      this.listadoAccionesParaAsociar = [];

      this.listadoAccionesParaAsociar.push(this.rowSelectedtoDelete);

      let dataIndicador = this.accionesAsociadas;
      this.$emit('updateDataIndicadorAccionesAsociadas', dataIndicador);
    },
    triggerAdd () {
      this.showPopUpAccionesAsociadas = true;
    },
    getImgObjetivo (file) {
      let res = this.searchResource(file, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    },
    getListadoAccionesAsociadas () {
      this.$store
        .dispatch(types.ACTION_GET_ACCIONES_ASOCIADAS, {
          idCiudad: this.ciudadSelected.id,
          idIndicadorAUE: this.idIndicador
        }).then((response) => {
          this.listadoAcciones = response.data;
          this.accionesAsociadas.forEach((item) => {
            for (let index in this.listadoAcciones) {
              if (this.listadoAcciones[index].id === item.id) {
                this.listadoAcciones.splice(index, 1);
              }
            }
          });
        })
        .catch(() => {
        });
    },
    getListadoAccionesAsociadasSatelitales () {
      this.$store
        .dispatch(types.ACTION_GET_ACCIONES_ASOCIADAS_SATELITALES, {
          idCiudad: this.ciudadSelected.id,
          idIndicador: this.idIndicador
        }).then((response) => {
          this.listadoAcciones = response.data;
          this.accionesAsociadas.forEach((item) => {
            for (let index in this.listadoAcciones) {
              if (this.listadoAcciones[index].id === item.id) {
                this.listadoAcciones.splice(index, 1);
              }
            }
          });
        })
        .catch(() => {
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }
    .q-table--no-wrap td {
      white-space: normal;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
    .q-icon {
      font-size: 1.5em
    }
  }
  .divAddPlan {
    margin-bottom: 15px;
  }
  .rigth {
    float: right;
  }
}
.divInfo {
  margin: 15px 0px 1px 0px;
  font-family: DINPro;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.09px;
  color: #555;
}
.q-img{
  height: 40px;
  width: 40px;
  margin-right: 5px;
}
</style>
